import {
  Container,
  CreatorContainer,
  MeetingTitle,
  Title,
  LabelContainer,
  MeetingRoomDataContainer,
  MeetingRoomTitle,
} from "./ViolationReservationItem.styles";
import UI from "@mile-meeting/mile-ui";
import MeetingRoomCard from "pages/meeting/booking-list/component/meeting-room-card";
import { TViolationRsvListItem } from "pages/meeting/MeetingRoomManage/MinimumAttendeesManagement/ViolationReservations/types";
import { getDay, getKorDate } from "utils/date";

const getTimeString = (time: string) => {
  const timeObj = new Date(time);
  return `${timeObj.getHours().toString().padStart(2, "0")}:${timeObj.getMinutes().toString().padStart(2, "0")}`;
};

const ViolationReservationItem = ({ violationRsvInfo }: { violationRsvInfo: TViolationRsvListItem }) => {
  return (
    <Container>
      <MeetingTitle>
        <Title>
          <div style={{ maxWidth: violationRsvInfo.isRecurring ? "calc(100% - 66px)" : "100%" }}>
            <UI.Typography
              type="body01 normal"
              fontStyle="bold"
              color="var(--alias-color-label-neutral)"
              style={{
                width: "max-content",
                maxWidth: "100%",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {violationRsvInfo.isPrivate ? "비공개 회의" : violationRsvInfo.title}
            </UI.Typography>
          </div>
          {violationRsvInfo.isRecurring && <UI.Tag label="반복 예약" size="small" color="skyblue" />}
        </Title>
        <CreatorContainer>
          <div className="label">
            <UI.Icon name="person" size={16} color="var(--alias-color-label-alternative)" />
            <UI.Typography type="label01" fontStyle="bold" color="var(--alias-color-label-alternative)">
              예약자
            </UI.Typography>
          </div>
          <UI.Typography
            type="label01"
            fontStyle="regular"
            color="var(--alias-color-label-normal)"
            style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
          >
            {violationRsvInfo.isPrivate ? "비공개" : violationRsvInfo.reservationCreator?.member.nickname}
          </UI.Typography>
        </CreatorContainer>
      </MeetingTitle>
      <LabelContainer minWidth={120} maxWidth={240}>
        <MeetingRoomDataContainer>
          <MeetingRoomTitle>
            <UI.Typography type="body01 normal" fontStyle="bold" color="var(--alias-color-label-neutral)">
              {violationRsvInfo.meetingRoom.name}
            </UI.Typography>
            {violationRsvInfo.meetingRoom.meetingRoomIntegration?.integrationProvider === "GOOGLE" && (
              <UI.Icon name="google" size={16} />
            )}
          </MeetingRoomTitle>
          <MeetingRoomCard
            key={`${violationRsvInfo.meetingRoom.id}`}
            meetingRoom={violationRsvInfo.meetingRoom}
            isOnlyDetail={true}
          />
        </MeetingRoomDataContainer>
      </LabelContainer>
      <LabelContainer minWidth={100} maxWidth={120}>
        <UI.Typography type="label01" fontStyle="medium" color="var(--alias-color-label-normal)">
          {violationRsvInfo.reservationAttendees?.length ?? "-"}인&nbsp;
          <UI.Typography
            type="label01"
            fontStyle="medium"
            color="var(--alias-color-label-alternative)"
            style={{ display: "inline-block" }}
          >
            / {violationRsvInfo.minAttendeeNum ?? "-"}인
          </UI.Typography>
        </UI.Typography>
      </LabelContainer>
      <LabelContainer minWidth={200} maxWidth={220}>
        <UI.Typography type="label01" fontStyle="regular" color="var(--alias-color-label-normal)">
          {getKorDate(violationRsvInfo?.startTime ?? "").replaceAll(".", ". ")} (
          {getDay(violationRsvInfo?.startTime ?? "")}) {getTimeString(violationRsvInfo.startTime)} -{" "}
          {getTimeString(violationRsvInfo.endTime)}
        </UI.Typography>
      </LabelContainer>
    </Container>
  );
};

export default ViolationReservationItem;
